import React from 'react';

import { Pie } from '@ant-design/charts';
import MyPie from './pie'
import WidgetEchartConfig from './WidgetEchartConfig'

class WidgetEchartPie extends React.Component
{
    constructor( props )
    {
        super( props );

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);

    }

    /** 事件 */
    onEvent(chart, event) 
    {
        if( this.props.onEvent!==undefined )
        {
            if( event.type==="element:mousedown" )
            {
                this.props.onEvent( event, event.data.data );
            } 
        }      
    }

    /** 创建 config */
    buildConfig( option, data )
    {
        let config = {};

        if( option!==undefined )
        {
            config = {
                data: data.data,            
                angleField: option.yField!==undefined ? option.yField.name : 'value',
                colorField: option.xField!==undefined ? option.xField.name : 'name'
            };
        }

        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].pieConfig, ...option, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].pieConfig, ...option, ...config};
        }

        return config;
    }

    render()
    {
        const { option, data } = this.props; 
        
        // let config = {};
        let config = this.buildConfig(option, data);

        return <MyPie id="homepie" data={data}/>
        // return <Pie {...config} onEvent={this.onEvent}></Pie>
    }
}

export default WidgetEchartPie;